var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#8D8B96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0016 8.7998C18.8772 8.7998 16.3444 11.3554 16.3444 14.5079C16.3444 17.6604 18.8772 20.216 22.0016 20.216C25.1259 20.216 27.6587 17.6604 27.6587 14.5079C27.6587 11.3554 25.1259 8.7998 22.0016 8.7998Z",
    fill: "#F4F3F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0016 35.1998C25.8561 35.1998 29.3505 33.6439 31.9016 31.1206V30.2052C31.9016 26.6586 29.0522 23.7836 25.5373 23.7836H18.4658C14.9509 23.7836 12.1016 26.6586 12.1016 30.2052V31.1206C14.6526 33.6439 18.147 35.1998 22.0016 35.1998Z",
    fill: "#F4F3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.ff012ee9218777ebdb8ec998d8ea347f.svg";
export { ForwardRef as ReactComponent };